(function() {
    'use strict';

    angular
        .module('app')
        .directive('bgImageSrcSet', bgImageSrcSet);

    bgImageSrcSet.$inject = ['$window'];

    function bgImageSrcSet($window) {
        var directive = {            
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope) {
            function responsiveBackgroundImage(element) {
                var item = {};

                var update = function () {
                    let src = typeof item.img.currentSrc !== 'undefined' ? item.img.currentSrc : item.img.src;
                    if (item.src !== src) {
                        item.src = src;
                        item.element.style.backgroundImage = 'url("' + item.src + '")';

                    }
                }

                item.element = element;
                item.img = element.querySelector('img');
                item.src = '';

                item.img.addEventListener('load', function () {
                    update();
                });

                if (item.img.complete) {
                    update();
                }
            }

            let elements = document.querySelectorAll('.bg-responsive-image');
            for (let i = 0; i < elements.length; i++) {
                responsiveBackgroundImage(elements[i]);
            }
        }
    }

})();





//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_bgImageSrcSet.js
// module id = 17
// module chunks = 0